const MENU_BUILD_STORAGE_KEY = 'menuBuildProgress';

export type StoredMenuBuild = {
  companyId: number | string;
  jobId: string;
  menuName: string;
  merchantId: number | string;
  /** The build's outcome has already been tracked. */
  reported?: boolean;
};

// The active-build endpoint only returns unfinished builds, so a failure survives a reload here.
export function saveMenuBuildToStorage(build: StoredMenuBuild): void {
  try {
    localStorage.setItem(MENU_BUILD_STORAGE_KEY, JSON.stringify(build));
  } catch {
    /* storage full or unavailable */
  }
}

export function loadMenuBuildFromStorage(): StoredMenuBuild | null {
  try {
    const stored = localStorage.getItem(MENU_BUILD_STORAGE_KEY);

    return stored ? (JSON.parse(stored) as StoredMenuBuild) : null;
  } catch {
    return null;
  }
}

export function clearMenuBuildStorage(): void {
  try {
    localStorage.removeItem(MENU_BUILD_STORAGE_KEY);
  } catch {
    /* noop */
  }
}
